import { useEffect } from "react";

const ConstructionModal = ({
  open,
  onClose,
  title = "En construcción",
  message = "Disponible próximamente.",
  autoCloseMs = 7000,
}) => {
  useEffect(() => {
    if (!open || !autoCloseMs) return undefined;
    const timer = setTimeout(onClose, autoCloseMs);
    return () => clearTimeout(timer);
  }, [open, onClose, autoCloseMs]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl p-8 shadow-xl max-w-sm text-center">
        <h4 className="font-display text-xl font-bold mb-2">{title}</h4>
        <p className="text-sm text-brand-dark/70">{message}</p>
      </div>
    </div>
  );
};

export default ConstructionModal;
